import { render, staticRenderFns } from "./TeamUpdate.vue?vue&type=template&id=489d402d&scoped=true&"
import script from "./TeamUpdate.vue?vue&type=script&lang=js&"
export * from "./TeamUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d402d",
  null
  
)

export default component.exports